import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { AUTH_PATHS } from '../auth';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';
import { isLegacyLoginEnabled } from '../../../../environments/legacy-login';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-change-password-success',
  templateUrl: './change-password-success.component.html',
  styleUrls: ['./change-password-success.component.scss'],
  standalone: false,
})
export class ChangePasswordSuccessComponent implements OnInit {
  public AUTH_PATHS = AUTH_PATHS;
  public ChangePasswordSuccessBreadcrumbs: Breadcrumb[] = [{ text: 'Восстановление доступа', url: null }];

  constructor(
    private router: Router,
    private breadcrumbsService: BreadcrumbsService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.router.navigate(['/' + (isLegacyLoginEnabled() ? AUTH_PATHS.login_legacy : AUTH_PATHS.login)]);
    }, 3000);

    this.breadcrumbsService.updateBreadcrumbs(this.ChangePasswordSuccessBreadcrumbs);
  }
}
